// @ts-check

// const workaround = require('next-translate/lib/cjs/plugin/utils');
// workaround.defaultLoader = '(l, n) => import(`locales/${l}/${n}.json`).then(m => m.default)';

/**
 * @type {import('next-translate').I18nConfig} config
 */
module.exports = {
  locales: ['vi', 'en'],
  defaultLocale: 'en',
  domains: [
    {
      domain: process.env.EXAM_US_DOMAIN,
      defaultLocale: 'en',
    },
  ],
  localeDetection: false,
  pages: {
    '*': ['common', 'error', 'modal', 'popover', 'account'],
    'rgx:(/login|/signup|/recover|/verify-account|/signup-new)$': ['auth'],
    'rgx:(/checkout)': ['checkout'],
    '/[lang]': ['home'],
    '/[lang]/second-page': ['home'],
  },
  // @ts-ignore
  loadLocaleFrom: (lang, ns) => {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    return Promise.resolve(require(`./src/locales/${lang}/${ns}.json`));
  },
  logBuild: true,
};
